<template>
  <div class="details-table relative col-11 sm-col-10 lg-col-8 mx-auto">
    <div class="row clearfix border-top py1">
      <div class="col col-3 pr1">Date/Time</div>
      <div class="col col-9">{{ processDate(event.data.date) }}, 2019 - {{ getText(event.data.times) }}</div>
    </div>
    <div class="row clearfix border-top py1">
      <div class="col col-3 pr1">Venue</div>
      <div class="col col-9">
        <a v-if="event.data.event_link.hasOwnProperty('url')" :href="event.data.event_link.url" target="_blank">{{ getText(event.data.title) }} ({{ getText(event.data.beach_title) }})</a>
        <span v-else>{{ getText(event.data.title) }} ({{ getText(event.data.beach_title) }})</span>
      </div>
    </div>
    <div v-if="event.data.meeting_point.length" class="row clearfix border-top py1">
      <div class="col col-3 pr1">Meeting Point</div>
      <div class="col col-9">{{ getText(event.data.meeting_point) }}</div>
    </div>
    <div class="row clearfix border-top py1">
      <div class="col col-3 pr1">Map</div>
      <div class="col col-9">
        <!-- <a v-if="event.data.meeting_point" :href="mapSearchLink(getText(event.data.meeting_point))" target="_blank">To Google Maps ⤴</a> -->
        <a :href="mapLink(event.data.location)" target="_blank">To Google Maps ⤴</a>
      </div>
    </div>
    <div v-if="event.data.participate.length" class="row clearfix border-top py1">
      <div class="col col-3 pr1">Participate</div>
      <div class="col col-9">
        <a v-if="event.data.event_link.hasOwnProperty('url')" :href="event.data.event_link.url" target="_blank" v-text="`${getText(event.data.participate)} ⤴`"></a>
        <span v-else v-text="getText(event.data.participate)"></span>
      </div>
    </div>
    <div v-if="event.data.queries.length" class="row clearfix border-top py1">
      <div class="col col-3 pr1">Queries</div>
      <div class="col col-9" v-html="getHtml(event.data.queries)"></div>
    </div>
    <div class="row clearfix border-top py1">
      <div class="col col-3 pr1">Links</div>
      <div class="col col-9">
        <a :href="event.data.instagram.url" target="_blank">Instagram</a>, <a :href="event.data.facebook.url" target="_blank">Facebook</a>, <a :href="event.data.twitter.url" target="_blank">Twitter</a>
      </div>
    </div>

  </div>
</template>

<script>
import { getText, getHtml, processDate, mapLink, mapSearchLink } from '@/utils'
export default {

  name: 'EventDetails',

  data () {
    return {

    }
  },

  props: ['event'],

  methods: {
    getText,
    getHtml,
    processDate,
    mapLink,
    mapSearchLink
  }
}
</script>

<style lang="css" scoped>
  .details-table {
    margin-top: 6em;

    &>>>p {
      margin: 0;
    }

    a:hover, & >>> a:hover {
      color: var(--green);
    }
  }
</style>
